import http from "../utils/http-common";

class LtrCalculationDefaultsService {
  getAll() {
    return http.get("/ltr-defaults");
  }

  update(key, data) {
    return http.put(`/ltr-defaults/${key}`, data);
  }
}

export default new LtrCalculationDefaultsService();
